import { Link } from "react-router-dom";
import { PageHero } from "./Services";
import { Button } from "../../components/ui/button";
import { ShieldCheck, Timer, Lock, Cpu, Eye, BadgeDollarSign, ArrowRight } from "lucide-react";

const POINTS = [
  { icon: BadgeDollarSign, title: "Flat-Rate Guarantee", text: "The quote you approve is the invoice you pay. Hourly billing rewards slow crews — ours rewards execution." },
  { icon: ShieldCheck, title: "Vetted Operatives", text: "Background checks, structured training, and performance tracking on every crew member. No day labor, ever." },
  { icon: Timer, title: "Mission-Grade Punctuality", text: "Tight arrival windows and a 98.6% on-time rate. Your crew lead calls 30 minutes out — every time." },
  { icon: Lock, title: "Insured up to $1M", text: "Full coverage on every job. High-value items get documented condition reports before and after transit." },
  { icon: Cpu, title: "AI-Powered Operations", text: "CastleCorp OS assigns optimal crews, plans routes, and flags risks before they become problems." },
  { icon: Eye, title: "Total Visibility", text: "Your customer portal mirrors our command center: live status, crew details, documents, invoices, payments." },
];

export default function WhyCastleCorp() {
  return (
    <div>
      <PageHero overline="Why CastleCorp" title="The difference is operational."
        sub="Anyone can rent a truck. We built an operating system — and a culture — around flawless execution." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {POINTS.map((p) => (
            <div key={p.title} data-testid={`why-card-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="rounded-xl border bg-card p-8 card-lift">
              <div className="w-11 h-11 rounded-xl bg-[var(--cc-accent)]/10 flex items-center justify-center">
                <p.icon className="w-5 h-5 text-[var(--cc-accent)]" />
              </div>
              <h3 className="font-heading font-semibold text-lg mt-5">{p.title}</h3>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 rounded-2xl border bg-[#08080A] text-white p-10 lg:p-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 relative overflow-hidden">
          <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 100% 0%, rgba(0,229,255,0.1), transparent 50%)" }} />
          <div className="relative z-10">
            <h2 className="font-heading font-bold text-2xl lg:text-3xl tracking-tight">Compare us to anyone.</h2>
            <p className="text-white/50 mt-2 max-w-xl leading-relaxed">Request a quote from us and two competitors. Compare precision, professionalism, and price. We'll wait.</p>
          </div>
          <Link to="/quote" className="relative z-10">
            <Button data-testid="why-quote-button" size="lg" className="rounded-full h-12 px-8 btn-glow bg-[var(--cc-accent)] text-black hover:bg-[var(--cc-accent)]/90 font-semibold">
              Request Quote <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
